// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__3PUi6","skills":"About_skills__wGtkG"};